export const getCountryListMock = async (): Promise<any> => {
  const response = [
    { Name: 'Australia', Alpha3Code: 'AUS', Cioc: null },
    { Name: 'United States', Alpha3Code: 'US', Cioc: null },
  ];
  return new Promise((resolve, _reject) => {
    resolve(response);
  });
};

export const getToolTipsMock = async (): Promise<any> => {
  const response = [
    { Locator: 'needhelponformglobal', Body: '<h4>Title</h4>\n<p>Hello</p>' },
    { Locator: 'needassistanceonformglobal', Body: '<h4>Title</h4>\n<p>Hello</p>' },
  ];
  return new Promise((resolve, _reject) => {
    resolve(response);
  });
};
